import React from "react";
import ToolTip from "../../parts/tooltip";

const generateSortUrl = (field, query) => {
  const sortBy = field;
  const sortType = query.sortType && query.sortType === "asc" ? "desc" : "asc";
  return `/admin/reports?reports=pushCoaches&sortBy=${sortBy}&sortType=${sortType}`;
};

function View(props) {
  const { coaches, totalSubscribers, momentTZ, query } = props;

  return (
    <div>
      <form action="/admin/reports" method="GET">
        <div className="search search-coaches">
          <div className="flex items-center gap-4">
            <div className="column">
              <input type="hidden" name="reports" defaultValue="pushCoaches" />
              <input
                type="search"
                className="text-input"
                name="name"
                placeholder="Name"
                defaultValue={query.name}
              />
            </div>
            <div className="column">
              <input
                type="search"
                className="text-input"
                name="email"
                placeholder="E-mail"
                defaultValue={query.email}
              />
            </div>
            <div className="column">
              <button
                className="button-input"
                type="submit"
                data-button-type="primary"
              >
                Search
              </button>
            </div>
            <div className="column">
              <a
                className="button"
                target="_blank"
                href="/actions/refresh?reports=pushCoaches&csv=true"
                data-button-type="outline"
                role="button"
              >
                Export to csv
              </a>
            </div>
          </div>
        </div>
      </form>

      <div className="reports">
        <div className="labels">
          <div className="name">
            <a href={generateSortUrl("name", query)}>Coach</a>
          </div>
          <div className="trial">
            <a href={generateSortUrl("totalSubscribers", query)}>
              Subscribers ({totalSubscribers})
            </a>
          </div>
          <div className="last-logged">
            <a href={generateSortUrl("loggedIn", query)}>Last Logged In</a>
          </div>
        </div>

        {coaches &&
          coaches.map((coach) => {
            return (
              <div className="report collapsible" key={coach._id}>
                <input
                  type="checkbox"
                  id={`coach-toggle-${coach._id}`}
                  defaultChecked={false}
                />
                <div className="head">
                  <label
                    className="expand-toggle icon-green"
                    htmlFor={`coach-toggle-${coach._id}`}
                  />
                  <div className="name">
                    {coach.name}
                    <br />
                    <ToolTip id={`${coach.email}`} body={`${coach.email}`}>
                      <span className="email">({`${coach.email}`})</span>
                    </ToolTip>
                  </div>
                  <div className="trial">
                    {coach.subscribers ? coach.subscribers.length : 0}
                  </div>
                  <div className="last-logged">
                    {momentTZ(coach.loggedIn).format("ll")}
                  </div>
                </div>
                <div className="details">
                  <div className="user-details">
                    {coach.permissions.includes("coach") ? (
                      <div>
                        <b>Is a Pull Coach too.</b>
                      </div>
                    ) : null}
                    <div>
                      <b>Member since: </b>
                      {momentTZ(coach.registered).format("MMMM, YYYY")}
                    </div>
                  </div>
                  {!coach.subscribers ||
                    (coach.subscribers.length === 0 && (
                      <span>No subscribers</span>
                    ))}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default View;
